import { Heading, Icon, Tappable } from "@trueskin-web/components"
import { arrowShortRightIcon } from "@trueskin-web/theme/icons/arrowShortRightIcon"

const ProductCard = ({
  title,
  description,
  image: Image,
  label,
  className,
  onClick,
}) => (
  <Tappable
    onClick={onClick}
    sx={{
      p: 3,
      display: "grid",
      gridTemplateColumns: "32px auto 1fr",
      alignItems: "center",
      gap: 3,
      border: "1px",
      borderColor: "grey",
      borderRadius: "8px",
      width: "100%",
    }}
    className={className}
  >
    <Image />
    <div sx={{ fontSize: 1, lineHeight: "body" }}>
      <Heading
        as="h4"
        sx={{ fontSize: "inherit", color: "#FFF", fontWeight: "bold" }}
      >
        {title}
      </Heading>
      <div sx={{ color: "#E5E5E5", mb: label ? 1 : 0 }}>{description}</div>

      {label && (
        <div
          sx={{
            mt: 1,
            padding: "4px 8px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "11px",
            lineHeight: "1.09",
            color: "#FFF",
            border: "1px solid #767676",
            borderRadius: "32px",
          }}
        >
          {label}
        </div>
      )}
    </div>
    <Icon
      icon={arrowShortRightIcon}
      size="sm"
      sx={{
        ml: "auto",
        mr: 5,
        "& image": {
          display: "none",
        },
        width: "24px",
        height: "24px",
        maskImage: `url(${arrowShortRightIcon})`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        backgroundColor: "brandNeutralsMediumGrey",
      }}
      asImage={true}
    />
  </Tappable>
)

export default ProductCard
